// ostaCalculator.js
function calculateOSTA(weight, age) {
    // 数値計算結果をそのまま返す（文字列ではなく）
    return (weight - age) * 0.2;
}

// 表示用のフォーマット関数
function formatOSTA(ostaValue) {
    return ostaValue.toFixed(1);
}

module.exports = {
    calculateOSTA,
    formatOSTA
};